import { faker } from '@faker-js/faker'
import type { Vendor } from '../../types/product'
import { LOCATIONS } from '../seeds/categories'

export function createVendor(): Vendor {
  return {
    id: faker.string.uuid(),
    name: faker.company.name(),
    slug: faker.helpers.slugify(faker.company.name()).toLowerCase(),
    is_verified: (faker.helpers as any).maybe(() => true, { probability: 0.7 }) ?? false,
    rating: faker.number.float({ min: 3.5, max: 5.0, fractionDigits: 1 }),
    product_count: faker.number.int({ min: 10, max: 500 }),
    location: (faker.helpers as any).arrayElement(LOCATIONS),
  }
}
